/**
 * The compass directions a camera can publish an image for, in the order the Gateway uses.
 *
 * The keys are the names of the Gateway's CompassDirection enum, which is what
 * cameraReport.json puts in a camera cell's imageDirections map, and the labels are what
 * that enum's getString() returns.
 *
 * The order is the enum's declaration order, because that is the server's own:
 * imageDirections is serialized from an EnumMap, and DelcanCamera.sortedThumbnails()
 * sorts by the same ordinal to pick the cell's `direction` - the one it means the viewer
 * to see first. Following it here keeps the carousel opening on that direction. It also
 * leaves cardinal-only cameras exactly as they were: with the diagonals filtered out,
 * this is still North, South, East, West.
 */
export const CAMERA_DIRECTIONS = [
  { key: "N", label: "North" },
  { key: "NE", label: "Northeast" },
  { key: "NW", label: "Northwest" },
  { key: "S", label: "South" },
  { key: "SE", label: "Southeast" },
  { key: "SW", label: "Southwest" },
  { key: "E", label: "East" },
  { key: "W", label: "West" },
];

/**
 * Returns the entries of CAMERA_DIRECTIONS that the given imageDirections map has an
 * image for, in display order.
 *
 * NONE is deliberately not among them: it is the direction of a single-view camera's one
 * snapshot, and such a camera has no imageDirections map to begin with.
 */
export const imageDirectionsPresent = (imageDirections) => {
  if (imageDirections == null) {
    return [];
  }
  return CAMERA_DIRECTIONS.filter(
    (direction) => imageDirections[direction.key] != null,
  );
};

/**
 * Returns the human readable name of a CompassDirection key, or "" if it does not name a
 * direction an image can be published for - null, undefined, or NONE.
 */
export const directionLabel = (key) => {
  const direction = CAMERA_DIRECTIONS.find((d) => d.key === key);
  return direction ? direction.label : "";
};
